import { activeFrontendLocales, markets } from '@pkg/config/languages';
import type { Market } from '@pkg/config/languages/types';

/**
 * Markets offered in the language picker: only active frontend locales,
 * and markets with no active locale left are dropped.
 */
export function useLocaleOptions() {
  return { options: removeInactiveLocales(Object.values(markets)) };
}

/**
 * Remove locales from markets that are not active.
 * Remove entire markets if they now have no locales.
 */
function removeInactiveLocales(markets: Array<Market>) {
  return markets
    .map((market) => {
      const filteredLocales = market.locales.filter(locale =>
        activeFrontendLocales.includes(locale.localeCode),
      );

      return {
        ...market,
        locales: filteredLocales,
      };
    })
    .filter(market => market.locales.length > 0); // Remove countries with no valid locales left
}
